import script from "./CustomerListing.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerListing.vue?vue&type=script&setup=true&lang=js"

import "./CustomerListing.vue?vue&type=style&index=0&id=f8730100&lang=css"

const __exports__ = script;

export default __exports__